var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import LocalDataProvider from '@base/LocalDataContext';
import * as baobab from '@data/baobab/baobab';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import LanguageContextProvider from './base/LanguageProvider';
import { TagContextProvider } from './data/tag/tagContext';
import Routes from './navigation/Routes';
import { handleApiErrorMessage } from './util/message';
//@ts-ignore
import { useRoot } from 'baobab-react/hooks';
import { createHashHistory } from 'history';
import { CustomHashRouter } from './navigation/CustomHashRouter';
import { AuthContextProvider } from './providers/AuthProvider';
var hashHistory = createHashHistory();
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {},
    },
    mutationCache: new MutationCache({
        onError: function (error) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handleApiErrorMessage(error)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    }),
    queryCache: new QueryCache({
        onError: function (error, query) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (query.state.data === undefined) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, handleApiErrorMessage(error)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    }),
});
function App() {
    var Root = useRoot(baobab.root);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(AuthContextProvider, null,
            React.createElement(LocalDataProvider, null,
                React.createElement(TagContextProvider, null,
                    React.createElement(LanguageContextProvider, null,
                        React.createElement(Root, null,
                            React.createElement(CustomHashRouter, { hashHistory: hashHistory },
                                React.createElement(Routes, null)))))))));
}
export default App;
